module.exports = __webpack_public_path__ + "ionicons.2c2ae068be3b089e0a5b.eot";


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/assets/fonts/ionicons.eot?v=2.0.0
// module id = ../../../../../src/assets/fonts/ionicons.eot?v=2.0.0
// module chunks = styles